import type { ReactNode } from "react"

interface FormSectionHeadingProps {
    number: number
    children: ReactNode
    className?: string
}

// sous-titre numéroté des étapes Coordonnées AE/MS (§3.1), suivi d'un filet horizontal
export default function FormSectionHeading({ number, children, className = "" }: FormSectionHeadingProps) {
    return (
        <div className={`flex items-center gap-6 ${className}`}>
            <h3 className="m-0 shrink-0 font-recoleta text-[20px] font-bold text-[#393939]">
                {number}. {children}
            </h3>
            <span aria-hidden="true" className="h-px flex-1 bg-[#e5e7eb]" />
        </div>
    )
}
